import type { LIconName } from '@last/core-ui/paprika'
import type { LastProduct } from '@last/core/src/lastProducts'

export class SideMenuItem {
  name?: string
  key: string
  routeName?: string
  params?: Record<string, string>
  icon?: LIconName
  readyForMobile: boolean
  access: string[]
  products: (LastProduct | 'hardwareStore')[]
  submenu: SideMenuItem[]
  subRoutes: string[]
  feature?: string
  navigable: boolean
  collapsible: boolean
  type: 'navigation' | 'title' | 'cta' | string
  ctaText?: string
  ctaCallback?: () => void
  isBold: boolean
  isSelectedFunction?: () => boolean
  callback?: () => void
  locationType: ('singleLocation' | 'location' | 'organization')[]
  countries?: string[]
  featureFlag?: string
  tbai?: boolean

  constructor({
    name,
    key,
    routeName,
    params,
    icon,
    readyForMobile,
    access,
    products,
    submenu,
    subRoutes,
    feature,
    navigable,
    collapsible,
    type = 'navigation',
    isBold = false,
    ctaText,
    ctaCallback,
    isSelectedFunction,
    callback,
    locationType,
    countries,
    featureFlag,
    tbai
  }: {
    name?: string
    key: string
    routeName?: string
    params?: Record<string, string>
    icon?: LIconName
    readyForMobile?: boolean
    access?: string[]
    products?: (LastProduct | 'hardwareStore')[]
    submenu?: SideMenuItem[]
    subRoutes?: string[]
    feature?: string
    navigable?: boolean
    collapsible?: boolean
    type?: 'navigation' | 'title' | 'cta' | string
    ctaText?: string
    ctaCallback?: () => void
    isBold?: boolean
    isSelectedFunction?: () => boolean
    callback?: () => void
    locationType: ('singleLocation' | 'location' | 'organization')[]
    countries?: string[]
    featureFlag?: string
    tbai?: boolean
  }) {
    this.name = name

    this.routeName = routeName
    this.params = params
    this.icon = icon
    this.readyForMobile = readyForMobile ?? false
    this.access = access ?? []
    this.products = products ?? []
    this.submenu = submenu ?? []
    this.subRoutes = subRoutes ?? []
    this.feature = feature
    this.navigable = navigable ?? Boolean(routeName)
    this.collapsible = collapsible ?? Boolean(submenu && submenu.length > 0)
    this.type = type
    this.ctaText = ctaText
    this.ctaCallback = ctaCallback
    this.isBold = isBold
    this.isSelectedFunction = isSelectedFunction
    this.callback = callback
    this.locationType = locationType
    this.countries = countries
    this.featureFlag = featureFlag
    this.tbai = tbai ?? false

    this.key = params?.reportId ? `${routeName}${params?.reportId || ''}` : (key ?? routeName)
  }
}

export type SideMenuItemType = InstanceType<typeof SideMenuItem>
